<template>
  <div class="q-content" v-if="questionControl">
    <AppNavbar
      :placeholder="true"
      :options="options"
      :back="false"
      :showTabBar="false"
    >
    </AppNavbar>
    <div class="operate-content">
      <div class="close iconfont icon-cha" @click="bindClose"></div>
      <div
        v-if="questionControl.questionIndex > 0 && !disabledPre"
        @click.stop="bindPre"
        class="pre-question"
        :class="{ 'app-pre-question': isApp }"
        ><span class="iconfont icon-fanhui"></span>上一题</div
      >
    </div>
    <div v-for="(item, index) in questionControl.question.length" :key="index">
      <QuestionItem
        :ref="'question' + index"
        v-if="questionControl.questionIndex == index"
        @change="bindChange"
        :questionIndex="index"
        :question="questionControl.question"
        :imageData="questionImageData"
      ></QuestionItem>
    </div>
    <div class="btn-content">
      <div class="next-step" v-show="showNext" @click="bindNextQuestion"
        >选好了</div
      >
      <div
        class="confirm"
        v-show="questionControl.finished"
        @click="bindConfirm"
        >完成</div
      >
    </div>
    <CloseToast
      v-model="showClose"
      @confirm="bindToastConfirm"
      @cancel="bindToastCancel"
    />
    <AppLoading v-if="submiting" class="app-loading" />
  </div>
</template>
<script>
import AppLoading from '@/components/app/loading/loading.vue'
import AppNavbar from '@/components/app/nav-bar/index.vue'
import QuestionItem from './components/question-item.vue'
import CloseToast from './components/close-toast.vue'
import { QuestionData, QuestionImageData } from './data.js'
import QuestionControl from './control.js'
export default {
  components: {
    QuestionItem,
    CloseToast,
    AppNavbar,
    AppLoading
  },
  data() {
    return {
      options: {
        barBackgroundColor: 'transparent'
      },
      id: 0,
      isApp: false,
      questionControl: null,
      disabledPre: false,
      loaded: false,
      questionImageData: QuestionImageData,
      showClose: false,
      isSubmit: false,
      submiting: false
    }
  },
  computed: {
    /* 是否显示下一题 问卷能下一题时并且题目类型不是单选 */
    showNext() {
      return (
        this.questionControl.canNext &&
        this.questionControl.question[this.questionControl.questionIndex]
          .field_type != 0
      )
    }
  },
  created() {
    this.id = this.$route.query.id
    this.isApp = this.$http._isApp()
    this.questionControl = new QuestionControl(QuestionData)
  },
  mounted() {},
  methods: {
    bindToastConfirm() {
      this.showClose = false
      setTimeout(() => {
        this.$http.appBack()
      }, 100)
    },
    bindToastCancel() {
      this.showClose = false
    },
    bindClose() {
      this.showClose = true
    },
    bindNextQuestion() {
      if (
        this.questionControl.question[this.questionControl.questionIndex]
          .field_type == 1
      ) {
        let el = this.$refs['question' + this.questionControl.questionIndex]
        el = Array.isArray(el) ? el[0] : el
        el.bindSetFadeOut(true)
        setTimeout(() => {
          this.questionControl.next()
        }, 500)
      } else {
        this.questionControl.next()
      }
    },
    bindConfirm() {
      if (this.isSubmit) {
        return
      }
      this.submiting = true
      let info = this.dealQuestionResult(this.questionControl.question)
      let params = {
        rid: this.$route.query.id,
        info: JSON.stringify(info),
        type: 9
      }
      this.$http
        .postBaseApp('member/AppCamp/posterQuestionSaveV2', params)
        .then((res) => {
          res = res.data
          if (res.code == 200) {
            this.isSubmit = true
            this.$router.replace({
              path: '/newcomer-questionnaire-v2/result',
              query: {
                id: this.$route.query.id,
                loading: 1
              }
            })
          } else {
            this.$toast(res.msg)
          }
        })
        .catch(() => {})
        .finally(() => {
          this.submiting = false
        })
    },
    dealQuestionResult(question) {
      let res = question.map((item) => {
        let obj = {
          field: item.field
        }
        if (
          ['age', 'height', 'weight', 'nutritional_goal_weight'].includes(
            item.field
          )
        ) {
          obj.value = item.value
        } else {
          obj.value = this.keyToLetter(item.value)
        }
        return obj
      })
      return res
    },
    //数字转小写字母
    keyToLetter(value) {
      if (Array.isArray(value)) {
        return value.map((item) => {
          return String.fromCharCode(item - 1 + 97)
        })
      } else {
        return value ? String.fromCharCode(value - 1 + 97) : ''
      }
    },
    bindChange() {
      this.questionControl.change()
    },
    bindPre() {
      this.disabledPre = true
      this.questionControl.pre()
      setTimeout(() => {
        this.disabledPre = false
      }, 600)
    }
  }
}
</script>
<style lang="scss" scoped>
.q-content {
  width: 100%;
  min-height: 100vh;
  position: relative;
  overflow: hidden;
  z-index: 1;
  background-color: #f5f5f5;
  .app-loading {
    position: fixed;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    z-index: 999;
  }
  .operate-content {
    position: relative;

    .close {
      width: 30px;
      height: 30px;
      position: absolute;
      left: 19px;
      font-size: 24px;
      font-weight: 600;
      display: flex;
      align-items: center;
      justify-content: center;
      top: 8px;
      color: rgba(0, 0, 0, 0.3);
    }

    .pre-question {
      position: absolute;
      top: 60px;
      left: 20px;
      z-index: 99;
      padding: 0px 15px 0px 10px;
      height: 22px;
      background: #ffffff;
      display: flex;
      align-items: center;
      justify-content: center;
      border-radius: 11px;
      font-size: 10px;
      font-family: PingFangSC-Semibold, PingFang SC;
      font-weight: 600;
      color: rgba(13, 13, 13, 0.5);

      .iconfont {
        width: 12px;
        height: 13px;
        display: flex;
        align-items: center;
        justify-content: center;
        font-weight: 600;
        font-size: 12px;
        color: rgba(13, 13, 13, 0.5);
      }
    }
  }

  .app-pre-question {
    top: 102px;
  }

  .btn-content {
    position: relative;
    z-index: 99;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 56px;

    .next-step,
    .confirm {
      width: 160px;
      height: 42px;
      background: #0d0d0d;
      border-radius: 21px;
      line-height: 42px;
      text-align: center;
      font-size: 16px;
      font-family: PingFangSC-Semibold, PingFang SC;
      font-weight: 600;
      color: #ffffff;
    }
  }
}
</style>
